module.exports = __webpack_public_path__ + "img/icon-waiting-verify-emedia.35588aa9.svg";